import "./styles.scss"

import React from "react"

const Heading = ({ title, description, html }) => {
  if (!title) return null

  return (
    <div className="csr-heading">
      <div className="row">
        <div className={`col-lg-${description || html ? "6" : "12"}`}>
          <h3>{title}</h3>
        </div>
        {(description || html) && <div className="col-lg-6">
          <div className="csr-heading__description">
            {html ? <div dangerouslySetInnerHTML={{ __html: html }} /> : <p>{description}</p>}
          </div>
        </div>}
      </div>
    </div>
  )
}

export default Heading
